const options = {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false,
};

/**
 * Formats a price number into a string suitable for tracking contexts.
 * This function ensures prices are consistently formatted with two decimal places
 * and proper thousand separators, following the specified locale.
 *
 * @param {number} price - The price in the smallest currency unit
 * @param {string} [locale='en-GB'] - The locale to use for formatting (default is 'en-GB').
 * @returns {string} The formatted price string, e.g., "3,999.00".
 */
export function formatNumber(price, locale = 'en-GB') {
    const formatter = new Intl.NumberFormat(locale, options);
    return formatter.format(price / 100);
}
